import React, { useState } from "react";
import { trackEvent } from "../../lib/eventTracking";
import { esDieciocho } from "../../lib/dieciocho";
import PanelDieciocho from "./PanelDieciocho";

// El enlace discreto que abre el panel del Dieciocho, con su propio estado:
// los dos lugares que lo usan (la landing y el Home con sesión) solo lo montan
// y se olvidan.
//
// Discreto a propósito: es una invitación, no una card ni un banner. Y se
// retira solo fuera del 17 al 19.
export default function EnlaceDieciocho({ className = "" }) {
  const [abierto, setAbierto] = useState(false);
  if (!esDieciocho()) return null;
  return (
    <div className={`text-center ${className}`}>
      <button
        type="button"
        onClick={() => {
          // Sin esto, el 20 de septiembre no habría forma de saber si alguien
          // lo abrió. Evento sin payload: no hay nada que medir salvo el acto.
          trackEvent("dieciocho_panel_abierto", { modulo: "home" });
          setAbierto(true);
        }}
        data-testid="enlace-dieciocho"
        className="inline-flex min-h-[44px] items-center text-small font-sans text-accent underline underline-offset-4 decoration-accent/40 hover:decoration-accent transition-colors"
      >
        ¿Por qué celebramos el 18 en Chile?
      </button>
      <PanelDieciocho abierto={abierto} onCerrar={() => setAbierto(false)} />
    </div>
  );
}
